import { Flex, IconCheck, IconCaretRight, csx } from '@vtex/admin-ui'
import type { FlexProps, StyleProp } from '@vtex/admin-ui'
import React, { useEffect, useRef } from 'react'

import { theme } from '../../../../core/theme/theme'

const getContainerStyles = ({
  selected,
}: {
  selected: boolean
}): StyleProp => ({
  height: '3.5rem',
  paddingX: '$space-5',
  cursor: 'pointer',
  fontWeight: selected ? 600 : 500, // NEED_PERFORMANCE_REVIEW
  userSelect: 'none',
  ':not(:last-child)': {
    borderBottom: `${theme.bg.NEED_PERFORMANCE_REVIEW_mid.tertiary}`,
  },
})

export type SalesAssociateMovementsTrackingModalItemProps = {
  onClick: () => void
  selected: boolean
  hasChildren?: boolean
} & FlexProps

export const SalesAssociateMovementsTrackingModalItem = ({
  onClick,
  children,
  selected,
  hasChildren,
  ...props
}: SalesAssociateMovementsTrackingModalItemProps) => {
  const ref = useRef<HTMLDivElement>(null)

  const setBackgroundColor = (color: string) => {
    if (ref.current) {
      ref.current.style.backgroundColor = color
    }
  }

  useEffect(() => {
    ref.current?.addEventListener('touchstart', () => {
      setBackgroundColor('#CAD7F1')
    })

    ref.current?.addEventListener('touchend', () => {
      setBackgroundColor('#fff')
    })
  }, [])

  return (
    <Flex
      align="center"
      justify="space-between"
      onClick={onClick}
      className={csx(getContainerStyles({ selected }))}
      ref={ref}
      {...props}
    >
      {children}
      {selected && !hasChildren && (
        <IconCheck
          data-testid="turn-list-modal-item-checked"
          className={csx({ color: 'NEED_PERFORMANCE_REVIEW_blue' })}
        />
      )}
      {!selected && hasChildren && <IconCaretRight />}
    </Flex>
  )
}
